import LoginImage from '@assets/images/login/Feature 1.webp';
import LoginImage2 from '@assets/images/login/Feature 2.webp';
import LoginImage3 from '@assets/images/login/Feature 3.webp';
import Logo from '@assets/svgs/auth/logo.svg';
import { useMemo } from 'react';
import AuthFooter from '../authFooter';
import AuthRedirectFooter from '../authSwitchPrompet';
import LeftSideAuthorization from '../leftSideAuthorization';
import MobileLog from '@assets/svgs/auth/rehabitair-mobile.svg';
import tw from 'twin.macro';

const AuthLayout = ({
  authSection,
  title,
  subtitle,
  hasAuthRedirectFooter,
  hasAuthFooter,
  redirectLink,
  redirectLinkText,
  redirectNormalText,
  footerLinkText,
  footerNormalText,
  aboveTitle,
  handelSubmit,
  parentRef,
  isLogIn = false,
  hideBorder,
  hasOpacity = true,
  customContainerStyle,
  authRedirectSection,
  footerLinkTestId,
}) => {
  // circle data for left side
  const circles = [{ id: 0 }, { id: 1 }, { id: 2 }];
  // auth data for left side (carousel copy)
  const authData = useMemo(
    () => [
      {
        title: 'Precise Adherence Tracking',
        subtitle:
          'Track patient adherence in real time, capturing exercise completion and execution quality, with detailed video analysis and timestamps to pinpoint errors and provide corrective feedback.',
        backgroundImage: LoginImage,
      },
      {
        title: 'Outcome-Driven Progress Measurement',
        subtitle:
          'Track rehabilitation progress through data-rich insights that measure improvements in mobility, posture, and fatigue over time—enabling more informed decisions, better outcomes, and personalized adjustments to keep your recovery on course.',
        backgroundImage: LoginImage2,
      },
      {
        title: 'Seamless Patient Onboarding',
        subtitle:
          'Join the platform effortlessly through health record integration, QR codes, or manual entry—allowing instant access to your prescribed program and removing barriers to getting started on your rehab journey.',
        backgroundImage: LoginImage3,
      },
    ],
    []
  );

  return (
    <div dir="ltr" tw="grid overflow-hidden grid-cols-1 h-[100dvh] lg:grid-cols-2">
      {/* Left Side: Video feed / Image */}
      <LeftSideAuthorization circles={circles} data={authData} logoImageUrl={Logo} />
      <div tw="flex flex-col lg:overflow-y-auto lg:h-[100vh]" className="element">
        <div tw="relative flex-1 lg:py-0 lg:bg-white">
          <div tw=" z-10 sticky max-lg:flex hidden top-0 left-0 bg-[#f8f9fa] justify-center">
            <img loading="lazy" decoding="async" alt="logo" width={162} src={MobileLog} tw="my-[48px]" />
          </div>
          <form
            onSubmit={handelSubmit}
            ref={parentRef}
            tw="flex justify-center md:max-lg:(px-[16.6%]) lg:items-center max-md:items-start px-[0%] max-lg:px-[0] max-sm:px-[4%] max-lg:max-h-[calc(100dvh-210px)] max-lg:overflow-y-auto lg:max-[1080px]:h-[calc(100dvh-20px)] min-[1080px]:h-[calc(100dvh-71px)]"
            className="element"
          >
            <div tw="w-[75%]" css={[isLogIn ? tw`space-y-4` : tw``, customContainerStyle]}>
              {aboveTitle && aboveTitle}
              <h1 tw="font-semibold lg:text-[1.5rem] text-[1rem] font-['Inter'] lg:pb-[0.75rem] pb-[0.375rem] max-lg:text-[1.25rem]">
                {title}
              </h1>
              <span
                tw="lg:text-[1.125rem] text-base [line-height: 100%] font-[500] font-['Inter'] max-md:font-[400]"
                css={hasOpacity ? tw`opacity-50` : tw``}
              >
                {subtitle}
              </span>
              {authSection && authSection}
              {hasAuthRedirectFooter && (
                <div
                  tw="space-y-3 max-md:space-y-6"
                  css={[isLogIn ? tw`` : tw`pt-[0.75rem]`, authRedirectSection]}
                >
                  <AuthRedirectFooter
                    link={redirectLink}
                    linkedText={redirectLinkText}
                    normalText={redirectNormalText}
                    hideBorder={hideBorder}
                  />
                </div>
              )}
            </div>
          </form>
        </div>

        {hasAuthFooter && (
          <div tw="shrink-0 sticky bottom-0 mx-auto w-full max-sm:mt-2">
            <AuthFooter
              onClick={() => changeOpenContactForm(true)}
              linkText={footerLinkText}
              normalText={footerNormalText}
              linkTestId={footerLinkTestId}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default AuthLayout;
